import get from 'lodash-es/get'

type TargetAttrType = {
  path: (string | number)[]
  defaultValue?: any
  key: string | number
  transform?: (value: any) => any
  before?: (args: any) => any
}

export const getAttr =
  (obj = {}, programCurrency: string) =>
  ({
    path,
    key,
    defaultValue = undefined,
    transform = (value) => value,
    before = ({ ...args }) => args,
  }: TargetAttrType): any => {
    const {
      obj: newObj = obj,
      path: newPath = path,
      key: newKey = key,
      defaultValue: newDefaultValue = defaultValue,
      transform: newTransform = transform,
    } = before({
      obj,
      path,
      key,
      defaultValue,
    })
    const resolvedPath =
      typeof newPath === 'function' ? newPath(programCurrency) : newPath

    try {
      const result = get(newObj, resolvedPath, newDefaultValue)
      return { [newKey]: newTransform(result) }
    } catch (error) {
      return { [newKey]: newDefaultValue }
    }
  }
